import { useMemo, useState } from "react";
import { Select, Button, Checkbox } from "@rio-cloud/rio-uikit";
import DatePicker from "@rio-cloud/rio-uikit/components/datepicker/DatePicker";
import { IChildForm } from "../../../";
import { OccurrenceStepLabelEnum } from "../../../../../enums/occurrenceStep";
import { applyTimeMask } from "../../../../../utils/dateUtils";
import Upload from "../../../../../components/form/upload";
import AddressSearch from "../../../../form/AddressSearch";
import { OccurrenceDispatch } from "../../../../../models/occurrence";
import DispatchForm from "./dispatch/dispatchForm";
import DispatchCard from "./dispatch/dispatchCard";
import ServiceBayScheduleCard from "./serviceBaySchedule/serviceBaySchedule";
import { ServiceBaySchedule } from "../../../../../models/serviceBay";
import { useEffect } from "react";
import { FailureType } from "../../../../../enums/failureTypes";
import { failureTypeToModeMap } from "../../../../../enums/failureTypeToModeMap";
import { PartsChildForm } from "./partsChildForm";
import { DtcAlertsHistoryDialog } from "../../../dialogs/dtcAlertsHistoryDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TasForm } from "./tasForm";
import { OccurrenceComments } from "./comments/occurrenceComments";

const ServiceChildForm = (props: IChildForm) => {
  const [newDispatches, setNewDispatches] = useState<OccurrenceDispatch[]>([]);

  const failureTypeOptions = useMemo(
    () => Object.values(FailureType).map((type) => ({ id: type, label: type })),
    []
  );

  const addZ = (s?: string | null) =>
    s ? (s.endsWith("Z") ? s : s + "Z") : "";

  const rawSteps = props.occurrence?.occurrenceSteps ?? [];
  const isMobile = useMediaQuery('(max-width: 768px)');

  const rawCurrentStep = useMemo(() => {
    const idAtual = props.step?.step;
    if (!idAtual) return undefined;

    const doMesmoTipo = rawSteps.filter((s) => s.stepId === idAtual);
    if (!doMesmoTipo.length) return undefined;

    return doMesmoTipo.slice().sort((a, b) => {
      const da = a.dtStart ? new Date(addZ(a.dtStart)).getTime() : 0;
      const db = b.dtStart ? new Date(addZ(b.dtStart)).getTime() : 0;
      return db - da;
    })[0];
  }, [rawSteps, props.step?.step]);

  useEffect(() => {
    if (!props.occurrence?.occurrenceType) {
      props.setOccurrenceValue("occurrenceType", "undefined");
    }
    if (
      props.occurrence?.vehicleStopped === undefined ||
      props.occurrence?.vehicleStopped === null
    ) {
      props.setOccurrenceValue("vehicleStopped", false);
    }
    if (
      props.occurrence?.vehicleCriticalPayload === undefined ||
      props.occurrence?.vehicleCriticalPayload === null
    ) {
      props.setOccurrenceValue("vehicleCriticalPayload", false);
    }
  }, []);

  const getUpdatedData = () => {
    const currentStep = props.occurrence?.steps?.find(
      (step) => step.step === props.step?.step
    );
    if (currentStep && currentStep.updatedBy && currentStep.updatedAt) {
      return (
        "Atualizado por " +
        currentStep.updatedBy +
        " em " +
        currentStep.updatedAt?.toLocaleDateString("pt-BR") +
        " as " +
        currentStep.updatedAt?.toLocaleTimeString("pt-BR")
      );
    }
    return "";
  };

  return (
    <>
      {props.hiddenFields.includes("serviceBaySchedule") ||
        (!["CONSULTANT"].includes(props.persona ?? "") &&
          !props.occurrence?.serviceBaySchedule) ? null : (
        <ServiceBayScheduleCard
          setServiceBaySchedule={(data?: ServiceBaySchedule | null) => {
            props.occurrence &&
              props.setOccurrenceValue("serviceBaySchedule", data ?? null);
            props.setServiceBayScheduleWasUpdated?.(true);
          }}
          occurrence={props.occurrence ?? undefined}
          disabled={
            props.disabledAllFields ||
            props.disabledFields.includes("serviceBaySchedule") ||
            !["CONSULTANT"].includes(props.persona ?? "")
          }
        />
      )}

      <div className="w-full my-6 p-6 pb-0 border rounded">
        {props.persona == "CONSULTANT" || props.persona == "TOWER" ? (
          <div
            className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
              }`}
          >
            {props.hiddenFields.includes("observation") ? null : (
              <>
                <div
                  className={`form-group form-group-lg w-full ${props.hasError &&
                    props.requiredFields.includes("observation") &&
                    !props.step?.observation
                    ? "has-error"
                    : ""
                    }`}
                >
                  <label htmlFor="observation" className="truncate">
                    Observações
                    {props.requiredFields.includes("observation") ? " *" : ""}
                  </label>
                  <textarea
                    id="observation"
                    className="form-control"
                    style={{ minHeight: 425 }}
                    placeholder="Observações"
                    rows={15}
                    value={props.occurrence?.observation}
                    onChange={(e) =>
                      props.occurrence &&
                      props.setOccurrenceValue("observation", e.target.value)
                    }
                    disabled={
                      props.disabledAllFields ||
                      props.disabledFields.includes("observation")
                    }
                    maxLength={10000}
                  />
                </div>
              </>
            )}
          </div>
        ) : null}
        {props.persona !== "MANAGER" && (
      <OccurrenceComments occurrenceId={props.occurrence?.id ?? ""} disabled={props.disabledAllFields} />
        )}

        {/* Campo de endereço do motorista (address search ou manual) */}
        {!props.hiddenFields.includes("driverCheckInDriver") &&
          props.occurrence?.occurrenceType !== "P" &&
          !props.occurrence?.scheduleNumber && (
            <div
              className={`form-group form-group-lg w-full mt-4 ${props.hasError &&
                props.requiredFields.includes("driverCheckInDriver") &&
                !props.occurrence?.driverCheckInDriver &&
                !props.occurrence?.manualDriverLocation
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="driverCheckInDriver" className="truncate">
                Localização do motorista
                {props.requiredFields.includes("driverCheckInDriver")
                  ? " *"
                  : ""}
              </label>
              <AddressSearch
                value={props.occurrence?.driverCheckInDriver}
                onAddressSelect={(address) =>
                  props.setOccurrenceValue(
                    "driverCheckInDriver",
                    address ?? null
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("driverCheckInDriver")
                }
              />
            </div>
          )}

        <div className="flex justify-between w-full gap-6 flex-wrap">
          {props.hiddenFields.includes("mechanicLocation") ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("mechanicLocation") &&
                !props.occurrence?.mechanicLocation
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="mechanicLocation" className="truncate">
                Localização do mecânico
                {props.requiredFields.includes("mechanicLocation") ? " *" : ""}
              </label>
              <AddressSearch
                value={props.occurrence?.mechanicLocation}
                onAddressSelect={(address) =>
                  props.occurrence &&
                  props.setOccurrenceValue("mechanicLocation", address ?? null)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("mechanicLocation")
                }
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("towTruckLocation") ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("towTruckLocation") &&
                !props.occurrence?.towTruckLocation
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="towTruckLocation" className="truncate">
                Localização do guincho
                {props.requiredFields.includes("towTruckLocation") ? " *" : ""}
              </label>
              <AddressSearch
                value={props.occurrence?.towTruckLocation}
                onAddressSelect={(address) =>
                  props.occurrence &&
                  props.setOccurrenceValue("towTruckLocation", address ?? null)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("towTruckLocation")
                }
              />
            </div>
          )}
        </div>

        {props.hiddenFields.includes("failures") ? null : (
          <div id="failures-container" className={`${(props.disabledAllFields || props.disabledFields.includes("failures")) && (props.occurrence?.failures?.length ?? 0) === 0 ? "hidden" : "relative border border-gray-300 rounded-md px-4 py-8 my-10"}`}>
            <div className="absolute -top-3 left-4 bg-white px-2 text-gray-600 font-medium">
              Falhas
            </div>
            {((props.occurrence?.failures?.length ?? 0) === 0 && !props.disabledAllFields && !props.disabledFields.includes("failures") 
              ? [{ failureType: undefined, failureMode: undefined, failureChecked: false }] 
              : props.occurrence?.failures ?? []
            ).map((failure, index) => (
              <div
                key={index}
                className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
                  }`}
              >
                <div className={`form-group form-group-lg w-full ${
                  props.hasError && 
                  (failure.failureType === undefined || failure.failureType === null || failure.failureType === "undefined")
                    ? "has-error" 
                    : ""
                }`}>
                  {index === 0 ? (
                    <label
                      htmlFor={`failureType-${index}`}
                      className="truncate"
                    >
                      Tipo de Falha *
                    </label>
                  ) : null}
                  <Select
                    key={`failureType-${index}-${failure.failureType || 'none'}`}
                    id={`failureType-${index}`}
                    placeholder="Selecione o tipo de falha"
                    value={failure.failureType && failure.failureType !== "undefined" ? [failure.failureType] : []}
                    options={[
                      ...failureTypeOptions,
                      ...(failure.failureType && failure.failureType !== "undefined" && !Object.values(FailureType).includes(failure.failureType as FailureType)
                        ? [{ id: failure.failureType, label: failure.failureType }]
                        : []),
                    ]}
                    useFilter
                    noItemMessage="Nenhum tipo de falha encontrado"
                    onChange={(e) => {
                      const failureType = e?.id ? (e.id as FailureType) : undefined;
                      const failureMode = failureType
                        ? failureTypeToModeMap[failureType]?.[0]
                        : undefined;

                      const currentFailures = props.occurrence?.failures ?? [];
                      let updatedFailures;

                      if (currentFailures.length === 0) {
                        updatedFailures = [
                          {
                            failureType,
                            failureMode,
                            failureChecked: false,
                          },
                        ];
                      } else {
                        updatedFailures = currentFailures.map(
                          (f, i) =>
                            i === index
                              ? {
                                ...f,
                                failureType,
                                failureMode,
                              }
                              : f
                        );
                      }
                      props.occurrence &&
                        props.setOccurrenceValue("failures", updatedFailures);
                    }}
                    disabled={props.disabledAllFields}
                  />
                </div>

                <div className="form-group form-group-lg w-full">
                  {index === 0 ? (
                    <label
                      htmlFor={`failureMode-${index}`}
                      className="truncate"
                    >
                      Modo de Falha
                    </label>
                  ) : null}
                  <input
                    id={`failureMode-${index}`}
                    className="form-control"
                    value={
                      failure.failureMode ??
                      (failure.failureType ? failureTypeToModeMap[failure.failureType as FailureType]?.[0] ?? "" : "")
                    }
                    disabled
                  />
                </div>

                <div className="form-group form-group-lg w-full">
                  {index === 0 ? (
                    <label
                      htmlFor={`failureChecked-${index}`}
                      className="truncate"
                    >
                      Falha Resolvida
                    </label>
                  ) : null}
                  <div className="mt-4">
                    <Checkbox
                      id={`failureChecked-${index}`}
                      checked={failure.failureChecked ?? false}
                      disabled={props.disabledAllFields || (!failure.failureType || failure.failureType === "undefined")}
                      onChange={() => {
                        const newCheckedValue = !failure.failureChecked;
                        const updatedFailures = props.occurrence?.failures?.map(
                          (f, i) =>
                            i === index
                              ? {
                                ...f,
                                failureChecked: newCheckedValue,
                              }
                              : f
                        );
                        props.occurrence &&
                          props.setOccurrenceValue("failures", updatedFailures);
                      }}
                    >
                      <span>Marcar como resolvida</span>
                    </Checkbox>
                  </div>
                </div>

                <div className="form-group form-group-lg">
                  <div
                    className='text-color-info cursor-pointer text-size-18 w-full h-full'
                    style={{
                      paddingTop: index == 0 ? 40 : 8,
                    }}
                    onClick={() =>
                      props.occurrence &&
                      props.setOccurrenceValue(
                        "failures",
                        (props.occurrence?.failures ?? []).filter(
                          (_, i) => i !== index
                        )
                      )
                    }
                  >
                    <span className="rioglyph rioglyph-trash text-color-info" />
                  </div>
                </div>
              </div>
            ))}

            {props.disabledAllFields ||
              props.disabledFields.includes("failures") ? null : (
              <Button
                bsStyle={Button.PRIMARY}
                className="cursor-pointer flex items-center mt-[5px]"
                onClick={() => {
                  props.occurrence &&
                    props.setOccurrenceValue("failures", [
                      ...(props.occurrence?.failures ?? []),
                      { failureType: undefined, failureMode: undefined, failureChecked: false },
                    ]);
                }}
              >
                <span className="rioglyph rioglyph-plus-sign"></span>
                <span className="font-bold">
                  Incluir Falha
                </span>
              </Button>
            )}
          </div>
        )}

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("criticality") ? null : (
            <div
              className={`form-group form-group-lg w-full mt-10 ${props.hasError &&
                props.requiredFields.includes("criticality") &&
                !props.occurrence?.criticality
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="criticality" className="truncate">
                Criticidade de atendimento
                {props.requiredFields.includes("criticality") ? " *" : ""}
              </label>
              <Select
                id="criticality"
                options={[
                  {
                    id: "undefined",
                    label: "Selecione a criticidade",
                  },
                  {
                    id: "5",
                    label: "Emergência",
                    icon: (
                      <span className="rioglyph rioglyph-sphere text-color-danger" />
                    ),
                  },
                  {
                    id: "4",
                    label: "Muito urgente",
                    icon: (
                      <span className="rioglyph rioglyph-sphere text-color-warning" />
                    ),
                  },
                  {
                    id: "3",
                    label: "Urgente",
                    icon: (
                      <span className="rioglyph rioglyph-sphere text-color-rating-3" />
                    ),
                  },
                  {
                    id: "2",
                    label: "Pouco urgente",
                    icon: (
                      <span className="rioglyph rioglyph-sphere text-color-rating-4" />
                    ),
                  },
                  {
                    id: "1",
                    label: "Não urgente",
                    icon: (
                      <span className="rioglyph rioglyph-sphere text-color-map-marker-route" />
                    ),
                  },
                ].map((group: any) => ({ id: group.id, label: group.label }))}
                value={[
                  props.occurrence?.criticality?.toString() ?? "undefined",
                ]}
                onChange={(e) => {
                  if (e && e.id !== "undefined") {
                    props.occurrence &&
                      props.setOccurrenceValue("criticality", Number(e.id));
                  } else {
                    props.occurrence &&
                      props.setOccurrenceValue("criticality", undefined);
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("criticality")
                }
              />
            </div>
          )}

          {props.hiddenFields.includes("createdBy") ? null : (
            <div
              className={`form-group form-group-lg w-full mt-10 ${props.hasError &&
                props.requiredFields.includes("createdBy") &&
                !props.occurrence?.createdBy
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="createdBy" className="truncate">
                Criado por
                {props.requiredFields.includes("createdBy") ? " *" : ""}
              </label>
              <input
                id="createdBy"
                className="form-control"
                value={
                  props.scheduling
                    ? props.scheduling.scheduledBy
                    : props.occurrence?.createdBy
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("createdBy")
                }
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("createdBy", e.target.value)
                }
                maxLength={100}
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("vehicleEntryAt") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehicleEntryAt") &&
                !props.occurrence?.vehicleEntryAt
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehicleEntryAt" className="truncate">
                Data/Hora entrada na concessionária
                {props.requiredFields.includes("vehicleEntryAt") ? " *" : ""}
              </label>
              {props.disabledAllFields || props.disabledFields.includes("vehicleEntryAt") ? (
                <input
                  id="vehicleEntryAt"
                  className="form-control"
                  value={props.occurrence?.vehicleEntryAt?.toLocaleString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                  disabled={true}
                />
              ) : (
                <DatePicker
                  id="vehicleEntryAt"
                  inputProps={{ placeholder: "Data/Hora entrada na concessionária" }}
                  className="pb-0 mb-0"
                  locale="pt-BR"
                  dateFormat="DD/MM/yyyy"
                  timeFormat="HH:mm"
                  initialValue={props.occurrence?.vehicleEntryAt}
                  onChange={(date) => {
                    if (props.occurrence) {
                      // Se vier como moment, converte para string no formato que o backend espera
                      let dateValue = date;
                      if (typeof date !== 'string' && date?.format) {
                        dateValue = date.format('YYYY-MM-DDTHH:mm:ss');
                      }
                      props.setOccurrenceValue("vehicleEntryAt", dateValue);
                    }
                  }}
                />
              )}
            </div>
          )}

          {props.hiddenFields.includes("dtStart") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("dtStart") &&
                !props.step?.dtStart
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="dtStart" className="truncate">
                Data/Hora de início da etapa
                {props.requiredFields.includes("dtStart") ? " *" : ""}
              </label>
              <input
                id="dtStart"
                className="form-control"
                value={props.step?.logs?.[0]?.startDate?.toLocaleString(
                  "pt-BR",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )}
                disabled={true}
              />
            </div>
          )}

          {props.hiddenFields.includes("dtEnd") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("dtEnd") &&
                !props.step?.dtEnd
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="dtEnd" className="truncate">
                Data/Hora de término da etapa
                {props.requiredFields.includes("dtEnd") ? " *" : ""}
              </label>
              <input
                id="dtEnd"
                className="form-control"
                value={
                  rawCurrentStep?.dtEnd
                    ? new Date(addZ(rawCurrentStep.dtEnd)).toLocaleString(
                      "pt-BR",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                    : props.step?.dtEnd
                      ? props.step.dtEnd.toLocaleString("pt-BR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                      : "-"
                }
                disabled={true}
              />
            </div>
          )}

          {props.hiddenFields.includes("vehicleExitAt") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehicleExitAt") &&
                !props.occurrence?.vehicleExitAt
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehicleExitAt" className="truncate">
                Data/Hora saída da concessionária
                {props.requiredFields.includes("vehicleExitAt") ? " *" : ""}
              </label>
              {props.disabledAllFields || props.disabledFields.includes("vehicleExitAt") ? (
                <input
                  id="vehicleExitAt"
                  className="form-control"
                  value={props.occurrence?.vehicleExitAt?.toLocaleString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                  disabled={true}
                />
              ) : (
                <DatePicker
                  id="vehicleExitAt"
                  inputProps={{ placeholder: "Data/Hora saída da concessionária" }}
                  className="pb-0 mb-0"
                  locale="pt-BR"
                  dateFormat="DD/MM/yyyy"
                  timeFormat="HH:mm"
                  initialValue={props.occurrence?.vehicleExitAt}
                  onChange={(date) => {
                    if (props.occurrence) {
                      // Se vier como moment, converte para string no formato que o backend espera
                      let dateValue = date;
                      if (typeof date !== 'string' && date?.format) {
                        dateValue = date.format('YYYY-MM-DDTHH:mm:ss');
                      }
                      props.setOccurrenceValue("vehicleExitAt", dateValue);
                    }
                  }}
                />
              )}
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("osNumber") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("osNumber") &&
                !props.occurrence?.osNumber
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="osNumber" className="truncate">
                Número da OS
                {props.requiredFields.includes("osNumber") ? " *" : ""}
              </label>
              <input
                id="osNumber"
                placeholder="Número da OS"
                className="form-control"
                value={props.occurrence?.osNumber ?? ''}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("osNumber", e.target.value)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("osNumber")
                }
                maxLength={100}
              />
            </div>
          )}

          {props.hiddenFields.includes("osDtOpenAt") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("osDtOpenAt") &&
                !props.occurrence?.osDtOpenAt
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="osDtOpenAt" className="truncate">
                Data/Hora de abertura da OS
                {props.requiredFields.includes("osDtOpenAt") ? " *" : ""}
              </label>
              {props.disabledAllFields ||
                props.disabledFields.includes("osDtOpenAt") ? (
                <input
                  id="osDtOpenAt"
                  className="form-control"
                  value={props.occurrence?.osDtOpenAt?.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                  disabled={true}
                />
              ) : (
                <DatePicker
                  id="osDtOpenAt"
                  inputProps={{ placeholder: "Data de abertura da OS" }}
                  className="pb-0 mb-0"
                  locale="pt-BR"
                  dateFormat="DD/MM/yyyy"
                  timeFormat="HH:mm"
                  initialValue={props.occurrence?.osDtOpenAt}
                  onChange={(date) => {

                    if (props.occurrence) {
                      const newDate = typeof date === 'string' ? new Date(date) : date?.toDate();
                      props.setOccurrenceValue("osDtOpenAt", newDate);
                    }
                  }}
                />
              )}
            </div>
          )}
        </div>

        {props.hiddenFields.includes("modules") ? null : (
          <div className={`${(props.disabledAllFields || props.disabledFields.includes("modules")) && ((props.occurrence?.modules ?? []).length ?? 0) === 0 ? "hidden" : "relative border border-gray-300 rounded-md px-4 py-8 my-10"}`}>
            <div className="absolute -top-3 left-4 bg-white px-2 text-gray-600 font-medium">
              Módulos
            </div>
            <DtcAlertsHistoryDialog chassis={props.occurrence?.vehicleChassis ?? ''} />
            {(props.occurrence?.modules ?? []).map((module, index) => (
              <div key={index} className="flex justify-between w-full gap-6">
                <div
                  className={`form-group form-group-lg w-full ${props.hasError &&
                    props.requiredFields.includes("modules") &&
                    !module.name
                    ? "has-error"
                    : ""
                    }`}
                >
                  {index === 0 ? <label htmlFor="module">Módulo</label> : null}
                  <input
                    id="module"
                    className="form-control"
                    value={module.name}
                    onChange={(e) => {
                      const newDtcModules = [
                        ...(props.occurrence?.modules ?? []),
                      ];
                      newDtcModules[index] = {
                        ...module,
                        name: e.target.value,
                        id: module.id,
                      };
                      props.occurrence &&
                        props.setOccurrenceValue("modules", newDtcModules);
                    }}
                    disabled={
                      module.disabled ||
                      props.disabledAllFields ||
                      props.disabledFields.includes("modules")
                    }
                  />
                </div>

                <div
                  className={`form-group form-group-lg w-full ${props.hasError &&
                    props.requiredFields.includes("modules") &&
                    !module.spn
                    ? "has-error"
                    : ""
                    }`}
                >
                  {index === 0 ? <label htmlFor="spn">SPN</label> : null}
                  <input
                    id="spn"
                    className="form-control"
                    value={module.spn}
                    onChange={(e) => {
                      const newDtcModules = [
                        ...(props.occurrence?.modules ?? []),
                      ];
                      newDtcModules[index] = {
                        ...module,
                        spn: e.target.value,
                        id: module.id,
                      };
                      props.occurrence &&
                        props.setOccurrenceValue("modules", newDtcModules);
                    }}
                    disabled={
                      module.disabled ||
                      props.disabledAllFields ||
                      props.disabledFields.includes("modules")
                    }
                  />
                </div>

                <div
                  className={`form-group form-group-lg w-full ${props.hasError &&
                    props.requiredFields.includes("modules") &&
                    !module.fmi
                    ? "has-error"
                    : ""
                    }`}
                >
                  {index === 0 ? <label htmlFor="fmi">FMI</label> : null}
                  <input
                    id="fmi"
                    className="form-control"
                    value={module.fmi}
                    onChange={(e) => {
                      if (!/^\d+$/.test(e.target.value)) return;

                      const newDtcModules = [
                        ...(props.occurrence?.modules ?? []),
                      ];
                      newDtcModules[index] = {
                        ...module,
                        fmi: e.target.value,
                        id: module.id,
                      };
                      props.occurrence &&
                        props.setOccurrenceValue("modules", newDtcModules);
                    }}
                    disabled={
                      module.disabled ||
                      props.disabledAllFields ||
                      props.disabledFields.includes("modules")
                    }
                  />
                </div>

                {props.disabledAllFields ||
                  props.disabledFields.includes("modules") ||
                  module.disabled ? null : (
                  <div className="form-group form-group-lg">
                    <div
                      className='text-color-info cursor-pointer text-size-18 w-full h-full'
                      style={{
                        paddingTop: index == 0 ? 40 : 8,
                      }}
                      onClick={() =>
                        props.occurrence &&
                        props.setOccurrenceValue(
                          "modules",
                          props.occurrence?.modules?.filter(
                            (m) => m.id !== module.id
                          )
                        )
                      }
                    >
                      <span className="rioglyph rioglyph-trash text-color-info" />
                    </div>
                  </div>
                )}
              </div>
            ))}

            {props.disabledAllFields ||
              props.disabledFields.includes("modules") ? null : (
              <Button
                bsStyle={Button.PRIMARY}
                className="padding-top-10 flex items-center gap-2 cursor-pointer ml-2"
                onClick={() =>
                  props.occurrence &&
                  props.setOccurrenceValue("modules", [
                    ...(props.occurrence?.modules ?? []),
                    {
                      id: new Date().getTime().toString(),
                      module: "",
                      spn: "",
                      fmi: "",
                    },
                  ])
                }
              >
                <span className="rioglyph rioglyph-plus-sign"></span>
                <span className="font-bold">
                  Adicionar DTC
                </span>
              </Button>
            )}
          </div>
        )}

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("literatureDiagnosis") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("literatureDiagnosis") &&
                !props.occurrence?.literatureDiagnosis
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="literatureDiagnosis" className="truncate">
                Leitura de diagnose
                {props.requiredFields.includes("literatureDiagnosis")
                  ? " *"
                  : ""}
              </label>
              <input
                id="literatureDiagnosis"
                className="form-control"
                value={props.occurrence?.literatureDiagnosis}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "literatureDiagnosis",
                    e.target.value
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("literatureDiagnosis")
                }
                maxLength={100}
              />
            </div>
          )}

          {props.hiddenFields.includes("literatureTroubleshooting") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("literatureTroubleshooting") &&
                !props.occurrence?.literatureTroubleshooting
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="literatureTroubleshooting" className="truncate">
                Literatura para troubleshooting
                {props.requiredFields.includes("literatureTroubleshooting")
                  ? " *"
                  : ""}
              </label>
              <input
                id="literatureTroubleshooting"
                className="form-control"
                value={props.occurrence?.literatureTroubleshooting}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "literatureTroubleshooting",
                    e.target.value
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("literatureTroubleshooting")
                }
                maxLength={100}
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("estimatedTime") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("estimatedTime") &&
                !props.step?.estimatedTime
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="expectedEndDate">
                Tempo Estimado para conclusão da Etapa
                {props.requiredFields.includes("expectedEndDate") ? " *" : ""}
              </label>
              {props.disabledAllFields ||
                props.disabledFields.includes("expectedEndDate") ? (
                <input
                  id="expectedEndDate"
                  className="form-control"
                  value={props.step?.expectedEndDate?.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                  disabled={true}
                />
              ) : (
                <DatePicker
                  id="expectedEndDate"
                  inputProps={{ placeholder: "Data estimada para conclusão" }}
                  className="pb-0 mb-0"
                  locale="pt-BR"
                  dateFormat="DD/MM/yyyy"
                  timeFormat="HH:mm"
                  initialValue={props.step?.expectedEndDate}
                  onChange={(date) => {
                    if (props.step) {
                      const newDate = typeof date === 'string' ? new Date(date) : date?.toDate();
                      props.setOccurrenceStepValue(
                        props.step.name as OccurrenceStepLabelEnum,
                        "expectedEndDate",
                        newDate
                      );
                    }
                  }}
                />
              )}
            </div>
          )}

          {props.hiddenFields.includes("estimateTimeRepair") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("estimateTimeRepair")
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="estimateTimeRepair">Previsão de Liberação</label>
              <input
                id="estimateTimeRepair"
                className="form-control"
                value={props.step?.expectedEndDate?.toLocaleString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                disabled={true}
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("protocolNumber") &&
              !props.occurrence?.protocolNumber
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="protocolNumber" className="truncate">
              Número da ocorrência
            </label>
            <input
              id="protocolNumber"
              className="form-control"
              value={props.occurrence?.protocolNumber ?? "-"}
              disabled={true}
            />
          </div>

          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("scheduleNumber") &&
              !props.occurrence?.scheduleNumber
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="scheduleNumber" className="truncate">
              Número do agendamento
            </label>
            <input
              id="scheduleNumber"
              className="form-control"
              value={props.occurrence?.scheduleNumber ?? "-"}
              disabled={true}
            />
          </div>

          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("dynamicsOccurrenceCode") &&
              !props.occurrence?.dynamicsOccurrenceCode
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="dynamicsOccurrenceCode" className="truncate">
              Ocorrência Dynamics
            </label>
            <input
              id="dynamicsOccurrenceCode"
              className="form-control"
              value={props.occurrence?.dynamicsOccurrenceCode}
              disabled={props.disabledAllFields || props.disabledFields.includes("dynamicsOccurrenceCode") ? true : false}
              onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "dynamicsOccurrenceCode",
                    e.target.value
                  )
                }
            />
          </div>
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("report") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("report") &&
                !props.step?.report
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="report" className="truncate">
                Relato{props.requiredFields.includes("report") ? " *" : ""}
              </label>
              <textarea
                id="report"
                className="form-control"
                style={{ height: 85 }}
                placeholder="Relato"
                rows={3}
                value={props.step?.report}
                onChange={(e) =>
                  props.step &&
                  props.setOccurrenceStepValue(
                    props.step.name as OccurrenceStepLabelEnum,
                    "report",
                    e.target.value
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("report")
                }
                maxLength={10000}
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("checklist") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("checklist") &&
                !props.occurrence?.checklist
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="checklist" className="truncate">
                Checklist de Inspeção
                {props.requiredFields.includes("checklist") ? " *" : ""}
              </label>
              <input
                id="checklist"
                className="form-control"
                value={props.occurrence?.checklist}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("checklist", e.target.value)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("checklist")
                }
                maxLength={100}
              />
            </div>
          )}
        </div>

        {props.persona !== "MANAGER" ? (
          <div
            className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
              }`}
          >
            {props.hiddenFields.includes("visualInspection") ? null : (
              <div
                className={`form-group form-group-lg w-full ${props.hasError &&
                  props.requiredFields.includes("visualInspection") &&
                  !props.occurrence?.visualInspection
                  ? "has-error"
                  : ""
                  }`}
              >
                <label htmlFor="visualInspection" className="truncate">
                  Inspeção visual
                  {props.requiredFields.includes("visualInspection")
                    ? " *"
                    : ""}
                </label>
                <Upload
                  id="visualInspection"
                  path={`kanban/${props.occurrence?.id}`}
                  disabled={
                    props.disabledAllFields ||
                    props.disabledFields.includes("visualInspection")
                  }
                  pendingFiles={!props.occurrence?.id ? props.pendingFiles : undefined}
                  onPickPending={!props.occurrence?.id ? props.onPickPending : undefined}
                  onRemovePending={!props.occurrence?.id ? props.onRemovePending : undefined}
                />
              </div>
            )}
          </div>
        ) : null}

        <PartsChildForm {...props} />

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("vehicleStopped") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehicleStopped") &&
                props.occurrence?.vehicleStopped === undefined
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehicleStopped" className="truncate">
                Unidade parada
                {props.requiredFields.includes("vehicleStopped") ? " *" : ""}
              </label>
              <Select
                id="vehicleStopped"
                options={[
                  {
                    id: "undefined",
                    label: "Selecione se a unidade está parada",
                  },
                  { id: "true", label: "Sim" },
                  { id: "false", label: "Não" },
                ]}
                value={[
                  props.occurrence?.vehicleStopped === undefined
                    ? "undefined"
                    : props.occurrence?.vehicleStopped
                      ? "true"
                      : "false",
                ]}
                onChange={(e) => {
                  if (e?.id === "true") {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleStopped", true);
                  } else if (e?.id === "false") {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleStopped", false);
                  } else {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleStopped", undefined);
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("vehicleStopped")
                }
              />
            </div>
          )}

          {/* {props.hiddenFields.includes("occurrenceType") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("occurrenceType") &&
                !props.occurrence?.occurrenceType
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="occurrenceType" className="truncate">
                Tipo de ocorrência
                {props.requiredFields.includes("occurrenceType") ? " *" : ""}
              </label>
              <Select
                id="occurrenceType"
                className="w-full"
                options={[
                  { id: "undefined", label: "Selecione o tipo de ocorrência" },
                  { id: "P", label: "Preventiva" },
                  { id: "C", label: "Corretiva" },
                  { id: "PC", label: "Preventiva e Corretiva" },
                  { id: "A", label: "Socorro" },
                  { id: "W", label: "Guincho" },
                  { id: "D", label: "Veículo na Concessionária" },
                ]
                  .filter((option) => {
                    if (
                      ["P", "PC", "C"].includes(option.id) &&
                      ["P", "PC", "C"].includes(props.occurrence?.occurrenceType ?? "")
                    ) return true;

                    else if (
                      ["A", "W", "D"].includes(option.id)
                    ) return true;

                    return false;
                  })}
                value={[props.occurrence?.occurrenceType ?? "undefined"]}
                onChange={(e) => {
                  if (e && e.id !== "undefined") {
                    props.occurrence &&
                      props.setOccurrenceValue("occurrenceType", e.id);
                  } else {
                    props.occurrence &&
                      props.setOccurrenceValue("occurrenceType", undefined);
                  }
                }}
                disabled={
                  ["P", "PC", "C"].includes(props.occurrence?.occurrenceType ?? "") ||
                  props.disabledAllFields ||
                  props.disabledFields.includes("occurrenceType")
                }
              />
            </div>
          )} */}

          {props.occurrence?.occurrenceType === "W" && (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("partner") &&
                !props.occurrence?.partnerId
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="partner" className="truncate">
                Guincho{props.requiredFields.includes("partner") ? " *" : ""}
              </label>
              <Select
                id="partner"
                className="w-full"
                options={[
                  { id: "undefined", label: "Selecione o guincho" },
                  ...(props.partners?.map((partner) => ({
                    id: partner.id,
                    label: partner.name,
                  })) ?? []),
                ]}
                value={[props.occurrence?.partnerId ?? "undefined"]}
                onChange={(e) => {
                  props.occurrence &&
                    props.setOccurrenceValue("partnerId", e?.id);
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("partner")
                }
              />
            </div>
          )}

          {props.hiddenFields.includes("timeOpenProtocol") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("timeOpenProtocol") &&
                !props.occurrence?.timeOpenProtocol
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="timeOpenProtocol" className="truncate">
                Tempo para abertura do protocolo
                {props.requiredFields.includes("timeOpenProtocol") ? " *" : ""}
              </label>
              {props.disabledAllFields ||
                props.disabledFields.includes("timeOpenProtocol") ? (
                <input
                  id="timeOpenProtocol"
                  className="form-control"
                  value={props.occurrence?.timeOpenProtocol}
                  disabled={true}
                />
              ) : (
                <div className="input-group">
                  <span className="input-group-addon">
                    <span className="rioglyph rioglyph-time"></span>
                  </span>
                  <input
                    id="timeOpenProtocol"
                    type="text"
                    className="form-control"
                    placeholder="Tempo para abertura do protocolo"
                    value={props.occurrence?.timeOpenProtocol ?? ""}
                    onChange={(e) => {
                      const maskedValue = applyTimeMask(e.target.value);

                      props.occurrence &&
                        props.setOccurrenceValue(
                          "timeOpenProtocol",
                          maskedValue
                        );
                    }}
                    maxLength={5}
                  />
                </div>
              )}
            </div>
          )}

          {props.hiddenFields.includes("country") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("country") &&
                !props.occurrence?.country
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="country" className="truncate">
                País solicitante
                {props.requiredFields.includes("country") ? " *" : ""}
              </label>
              <Select
                id="country"
                className="w-full"
                options={[
                  { id: "Brasil", label: "Brasil" },
                  { id: "Chile", label: "Chile" },
                  { id: "Argentina", label: "Argentina" },
                  { id: "Uruguai", label: "Uruguai" },
                  { id: "Honduras", label: "Honduras" },
                ]}
                value={[props.occurrence?.country ?? ""]}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "country",
                    e?.id === "" ? undefined : e?.id
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("country")
                }
              />
            </div>
          )}

          {props.hiddenFields.includes("source") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("source") &&
                !props.occurrence?.source
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="source" className="truncate">
                Origem{props.requiredFields.includes("source") ? " *" : ""}
              </label>
              <Select
                id="source"
                className="w-full"
                options={[
                  { id: "Torre de Controle", label: "Torre de Controle" },
                  { id: "DN", label: "DN" },
                  { id: "Cliente", label: "Cliente" },
                  { id: "Interno", label: "Interno" },
                ]}
                value={[props.occurrence?.source ?? ""]}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "source",
                    e?.id === "" ? undefined : e?.id
                  )
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("source")
                }
              />
            </div>
          )}
        </div>

        <TasForm {...props} />

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("hasLink") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("hasLink") &&
                (props.occurrence?.hasLink === undefined || props.occurrence?.hasLink === null)
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="hasLink" className="truncate">
                Possui vínculo
                {props.requiredFields.includes("hasLink") ? " *" : ""}
              </label>
              <Select
                id="hasLink"
                options={[
                  { id: "undefined", label: "Selecione se possui vínculo" },
                  { id: "true", label: "Sim" },
                  { id: "false", label: "Não" },
                ]}
                value={[
                  props.occurrence?.hasLink === true
                    ? "true"
                    : props.occurrence?.hasLink === false
                      ? "false"
                      : "undefined",
                ]}
                onChange={(e) => {
                  if (e?.id === "true") {
                    props.occurrence &&
                      props.setOccurrenceValue("hasLink", true);
                  } else if (e?.id === "false") {
                    if (props.occurrence) {
                      props.setOccurrenceValue("hasLink", false);
                      props.setOccurrenceValue("mainOccurrence", undefined);
                    }
                  } else {
                    if (props.occurrence) {
                      props.setOccurrenceValue("hasLink", undefined);
                      props.setOccurrenceValue("mainOccurrence", undefined);
                    }
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("hasLink")
                }
              />
            </div>
          )}

          {props.hiddenFields.includes("mainOccurrence") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("mainOccurrence") &&
                props.occurrence?.hasLink === true &&
                (props.occurrence?.mainOccurrence === undefined || props.occurrence?.mainOccurrence === null)
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="mainOccurrence" className="truncate">
                Ocorrência principal
                {props.requiredFields.includes("mainOccurrence") && props.occurrence?.hasLink === true ? " *" : ""}
              </label>
              <Select
                id="mainOccurrence"
                options={[
                  {
                    id: "undefined",
                    label: "Selecione se é uma ocorrência principal",
                  },
                  { id: "true", label: "Sim" },
                  { id: "false", label: "Não" },
                ]}
                value={[
                  props.occurrence?.mainOccurrence === true
                    ? "true"
                    : props.occurrence?.mainOccurrence === false
                      ? "false"
                      : "undefined",
                ]}
                onChange={(e) => {
                  if (e?.id === "true") {
                    props.occurrence &&
                      props.setOccurrenceValue("mainOccurrence", true);
                  } else if (e?.id === "false") {
                    props.occurrence &&
                      props.setOccurrenceValue("mainOccurrence", false);
                  } else {
                    props.occurrence &&
                      props.setOccurrenceValue("mainOccurrence", undefined);
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.occurrence?.hasLink !== true ||
                  props.disabledFields.includes("mainOccurrence")
                }
              />
            </div>
          )}

        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("vehiclePayloadType") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehiclePayloadType") &&
                !props.occurrence?.vehiclePayloadType
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehiclePayloadType" className="truncate">
                Carga
                {props.requiredFields.includes("vehiclePayloadType")
                  ? " *"
                  : ""}
              </label>
              <input
                id="vehiclePayloadType"
                className="form-control"
                value={props.occurrence?.vehiclePayloadType ?? ""}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("vehiclePayloadType", e.target.value)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("vehiclePayloadType")
                }
                maxLength={100}
              />
            </div>
          )}

          {props.hiddenFields.includes("vehicleMaximumPayload") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehicleMaximumPayload") &&
                !props.occurrence?.vehicleMaximumPayload
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehicleMaximumPayload" className="truncate">
                Peso da carga
                {props.requiredFields.includes("vehicleMaximumPayload")
                  ? " *"
                  : ""}
              </label>
              <input
                id="vehicleMaximumPayload"
                className="form-control"
                value={
                  props.occurrence?.vehicleMaximumPayload?.toString() ?? ""
                }
                onChange={(e) => {
                  if (
                    /^\d*$/.test(e.target.value) &&
                    !isNaN(parseInt(e.target.value))
                  ) {
                    props.occurrence &&
                      props.setOccurrenceValue(
                        "vehicleMaximumPayload",
                        parseInt(e.target.value)
                      );
                  } else if (e.target.value === "") {
                    props.occurrence &&
                      props.setOccurrenceValue(
                        "vehicleMaximumPayload",
                        undefined
                      );
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("vehicleMaximumPayload")
                }
                maxLength={100}
              />
            </div>
          )}

          {props.hiddenFields.includes("vehicleCriticalPayload") ||
            props.persona === "MANAGER" ||
            props.occurrence?.occurrenceType === "P" ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("vehicleCriticalPayload") &&
                props.occurrence?.vehicleCriticalPayload === undefined
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="vehicleCriticalPayload" className="truncate">
                Carga crítica
                {props.requiredFields.includes("vehicleCriticalPayload")
                  ? " *"
                  : ""}
              </label>
              <Select
                id="vehicleCriticalPayload"
                options={[
                  { id: "undefined", label: "Selecione se a carga é crítica" },
                  { id: "true", label: "Sim" },
                  { id: "false", label: "Não" },
                ]}
                value={[
                  props.occurrence?.vehicleCriticalPayload === undefined
                    ? "undefined"
                    : props.occurrence?.vehicleCriticalPayload
                      ? "true"
                      : "false",
                ]}
                onChange={(e) => {
                  if (e?.id === "true") {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleCriticalPayload", true);
                  } else if (e?.id === "false") {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleCriticalPayload", false);
                  } else {
                    props.occurrence &&
                      props.setOccurrenceValue(
                        "vehicleCriticalPayload",
                        undefined
                      );
                  }
                }}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("vehicleCriticalPayload")
                }
              />
            </div>
          )}
        </div>

        <div
          className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
            }`}
        >
          {props.hiddenFields.includes("solutionProposed") ? null : (
            <div
              className={`form-group form-group-lg w-full ${props.hasError &&
                props.requiredFields.includes("solutionProposed") &&
                !props.occurrence?.solutionProposed
                ? "has-error"
                : ""
                }`}
            >
              <label htmlFor="solutionProposed" className="truncate">
                Reparo/solução dada
                {props.requiredFields.includes("solutionProposed") ? " *" : ""}
              </label>
              <textarea
                id="solutionProposed"
                className="form-control"
                style={{ height: 85 }}
                value={props.occurrence?.solutionProposed}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("solutionProposed", e.target.value)
                }
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("solutionProposed")
                }
                maxLength={10000}
              />
            </div>
          )}
        </div>

        {props.upsertDispatch && props.cancelDispatch && (
          <>
            {[...(props.occurrence?.dispatches ?? []), ...newDispatches]?.map(
              (dispatch) => (
                <div
                  key={dispatch.id}
                  className="flex justify-between w-full gap-6 items-end my-6 p-6 pb-0 border rounded"
                >
                  <div className="form-group form-group-lg w-full">
                    <span className="text-color-dark">
                      Dados do acionamento
                    </span>

                    <DispatchCard
                      status={dispatch.status}
                      occurrence={props.occurrence}
                      occurrenceDispatch={dispatch}
                      cancelDispatch={props.cancelDispatch}
                      removeDispatch={props.removeDispatch}
                      persona={props.persona}
                    />
                  </div>
                </div>
              )
            )}

            {props.disabledAllFields ||
              !["TOWER"].includes(props.persona ?? "") ||
              ["V", "P"].includes(
                props.occurrence?.occurrenceType ?? ""
              ) ? null : (
              <DispatchForm
                occurrence={props.occurrence}
                upsertDispatch={props.upsertDispatch}
                updateDispatchList={(dispatch: OccurrenceDispatch) =>
                  setNewDispatches([...newDispatches, dispatch])
                }
                dispatches={props.occurrence?.dispatches ?? []}
                persona={props.persona}
                clickedChassis={props.occurrence?.vehicleChassis}
                removeDispatch={props.removeDispatch}
              />
            )}
          </>
        )}

        <div className="text-color-dark py-4 px-2 italic">
          {getUpdatedData()}
        </div>

        {/* Exibição dos atributos de finalização se estiverem preenchidos */}
        {(props.occurrence?.finalizationReasonType || props.occurrence?.finalizationReasonDescription) && (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-md mb-6">
            <h4 className="font-semibold text-green-700 mb-3">
              Justificativa para finalização antecipada
            </h4>

            {props.occurrence?.finalizationReasonDescription && (
              <div>
                <p className="text-green-600 mt-1">
                  {props.occurrence.finalizationReasonDescription}
                </p>
              </div>
            )}
          </div>
        )}
      </div >

    </>
  );
};

export default ServiceChildForm;
